import posthog from 'posthog-js';

function isPostHogEnabled() {
  if (typeof window === 'undefined') return false;
  return window.location.hostname !== 'staging.bizbuzz.app';
}

export function initPostHog() {
  if (!isPostHogEnabled()) return;

  posthog.init('phc_h2tLSqC33Vz0WBcrPxmefaMyekL7RsvKaI8woc6tG56', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
  });
}

export function identifyUser(userId: string, properties: Record<string, unknown>) {
  if (!isPostHogEnabled()) return;
  posthog.identify(userId, properties);
}

export function resetAnalytics() {
  if (!isPostHogEnabled()) return;
  posthog.reset();
}

export { posthog };
